import axios from 'axios';
import cacheConfig from './cache.config';
import { handleRequestCaching, handleResponseCaching } from './utils.cache';
import { OktaAuth } from '@okta/okta-auth-js';
import moment from 'moment';
import { encode } from 'utf8';

const { baseUrl } = window['runConfig'];
const { pkce, issuer, clientId, redirectUri, scopes } = window['oidc'];

export const authClient = new OktaAuth({
  baseUrl: issuer.split('/oauth2')[0],
  issuer,
  clientId,
  redirectUri,
  i18n: {
    en: {
      'primaryauth.title': 'Sign in to RAM',
    },
  },
  authParams: {
    pkce,
    issuer,
    display: 'page',
    responseMode: pkce ? 'query' : 'fragment',
    scopes,
  },
});

async function renewSessionAndTokens() {
  let authTokens = await authClient.tokenManager.getTokens();

  if (authTokens.accessToken && authTokens.idToken) {
    const today = moment();
    const accessTokenExpirationDate = moment.unix(
      authTokens?.accessToken?.expiresAt,
    );
    const idTokenExpirationDate = moment.unix(authTokens?.idToken?.expiresAt);

    if (
      today.isSameOrAfter(accessTokenExpirationDate) ||
      today.isSameOrAfter(idTokenExpirationDate)
    ) {
      await authClient.session.refresh();

      authTokens = await authClient.token.getWithoutPrompt({
        responseType: 'id_token',
      });

      authClient.tokenManager.setTokens(authTokens);
    }
  }

  return authTokens;
}

async function axiosSessionInterceptor(config) {
  const authTokens = await renewSessionAndTokens();

  const perms = await localStorage.getItem('permissions');
  const selectedLanguage = localStorage.getItem('selectedLanguage');

  let Permissions = null;

  if (perms) {
    Permissions = await atob(localStorage.getItem('permissions'));
  }

  let Profile = await localStorage.getItem('profile');
  if (Profile) Profile = encode(Profile);

  if (config.url.includes(window['runConfig'].frumBaseUrl)) {
    config.headers = {
      Authorization: `Bearer ${authTokens.idToken?.idToken}`,
      'source-call': 'ram',
    };
  } else {
    config.headers = {
      Authorization: `Bearer ${authTokens.idToken?.idToken}`,
      'source-call': 'ram',
      Permissions,
      Profile,
      'selected-language': selectedLanguage || 'eng',
    };
    const brand = await localStorage.getItem('brand-id');
    config.headers['brand-id'] = brand;
  }

  return config;
}

// Axios configurations
axios.defaults.baseURL = baseUrl;

export const setToken = async () => {
  axios.interceptors.request.use(axiosSessionInterceptor);

  axios.interceptors.request.use(request =>
    handleRequestCaching(request, cacheConfig),
  );

  axios.interceptors.response.use(response =>
    handleResponseCaching(response, cacheConfig),
  );

  axios.interceptors.response.use(
    res => res,
    err => {
      return Promise.reject(err);
    },
  );
};
